import _taggedTemplateLiteral from '@babel/runtime/helpers/esm/taggedTemplateLiteral';
import { lighten } from 'polished';
export { rgba } from 'polished';
import { reduce } from 'lodash';
import DSTheme, { toMobile, __UNSAFE_FONT_TO_DIMSUM } from './theme.js';
import '@babel/runtime/helpers/esm/slicedToArray';
import 'react';
import '@elliemae/pui-theme';
import './arithmetic.js';

var _templateObject;

var styled = require('styled-components');

var css = styled.css;
var kfrm = styled.keyframes;
var withTheme = styled.withTheme;
var useTheme = styled.useTheme;
var createGlobalStyle = styled.createGlobalStyle;
function truncate(width) {
  return function (props) {
    return css(["", " white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"], !!width || props.width ? "width: ".concat(props.width || width, ";") : '');
  };
} // iterate through the sizes and create a media template

var media = Object.keys(DSTheme.mediaQueries).reduce(function (accumulator, label) {
  // use em in breakpoints to work properly cross-browser and support users
  // changing their browsers font-size: https://zellwk.com/blog/media-query-units/
  accumulator[label] = function () {
    return css(["@media ", "{", ";}"], function (props) {
      return props.theme.mediaQueries[label];
    }, css.apply(void 0, arguments));
  };

  return accumulator;
}, {});
function flexCenter() {
  return "\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  ";
}
function disabled() {
  return "\n    cursor: not-allowed;\n    pointer-events: none;\n  ";
}
function keyframes(obj) {
  return kfrm(_templateObject || (_templateObject = _taggedTemplateLiteral(["", "\n  "])), reduce(obj, function (result, value, key) {
    return "\n    ".concat(result, "\n    ").concat(key, "% {\n      ").concat(value, "\n    }\n  ");
  }, ''));
} // eslint-disable-next-line max-params

function boxShadow(top, left, blur, color) {
  var inset = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  return "box-shadow: ".concat(inset ? 'inset' : '', " ").concat(top, " ").concat(left, " ").concat(blur, " ").concat(color, ";");
}
function color() {
  var variant = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'neutral';
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 400;
  return css(["color:", ";"], function (props) {
    return props.theme.colors[variant][type];
  });
}
function border() {
  var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DSTheme.colors.brand['600'];
  var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '1px';
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'solid';
  return "".concat(size, " ").concat(type, " ").concat(color);
}
function animation(animationKeyframes, animationLength, animationTimingFn) {
  return function (props) {
    return css(["animation:", " ", " ", ";"], props.animationKeyframes || animationKeyframes, props.animationLength || animationLength, props.animationTimingFn || animationTimingFn);
  };
} // 0.0769

function focus() {
  var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DSTheme.colors.brand['600'];
  return function () {
    return css(["outline:none;border:1px solid ", ";box-shadow:inset 0 0 0 1px ", ";border-radius:2px;"], color, lighten(0.3, color));
  };
}
function focusAfter(color) {
  return css(["outline:none;position:relative;&:after{content:'';z-index:10;position:absolute;top:0;left:0;width:100%;height:100%;pointer-events:none;", "}"], focus(color));
}
function active() {
  return function (props) {
    return css(["outline:none;border:1px solid ", ";border-radius:2px;"], props.theme.colors.brand['700']);
  };
}
function hover() {
  return function (props) {
    return css(["outline:1px solid ", ";outline-offset:-1px;"], props.theme.colors.brand['600']);
  };
}
function textStyle(type) {
  var weight = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'regular';
  // eslint-disable-next-line complexity
  return function (props) {
    var cssVar = "font-weight: ".concat(props.theme.fontWeights[weight], ";"); // eslint-disable-next-line default-case

    switch (type) {
      case 'h1':
        cssVar += "\n        font-size: ".concat(toMobile(props.theme.fontSizes[__UNSAFE_FONT_TO_DIMSUM(900)]), ";\n        line-height: normal;\n      ");
        break;

      case 'h2':
        cssVar += "\n        font-size: ".concat(toMobile(props.theme.fontSizes[__UNSAFE_FONT_TO_DIMSUM(800)]), ";\n        line-height: normal;\n      ");
        break;

      case 'h3':
        cssVar += "\n        font-size: ".concat(toMobile(props.theme.fontSizes[__UNSAFE_FONT_TO_DIMSUM(700)]), ";\n        line-height: 1.2;\n      ");
        break;

      case 'h4':
        cssVar += "\n        font-size: ".concat(toMobile(props.theme.fontSizes[__UNSAFE_FONT_TO_DIMSUM(600)]), ";\n        line-height: normal;\n      ");
        break;

      case 'h5':
        cssVar += "\n        font-size: ".concat(toMobile(props.theme.fontSizes[__UNSAFE_FONT_TO_DIMSUM(500)]), ";\n        line-height: normal;\n      ");
        break;

      case 'section-header':
        cssVar += "\n        font-size: ".concat(toMobile(props.theme.fontSizes[__UNSAFE_FONT_TO_DIMSUM(500)]), ";\n        line-height: normal;\n        text-transform: uppercase;\n      ");
        break;

      case 'body':
        cssVar += "\n        font-size: ".concat(toMobile(props.theme.fontSizes[__UNSAFE_FONT_TO_DIMSUM(400)]), ";\n        line-height: normal;\n      ");
        break;

      case 'body-small':
        cssVar += "\n        font-size: ".concat(toMobile(props.theme.fontSizes[__UNSAFE_FONT_TO_DIMSUM(300)]), ";\n        line-height: normal;\n      ");
        break;

      case 'body-micro':
        cssVar += "\n        font-size: ".concat(toMobile(props.theme.fontSizes[__UNSAFE_FONT_TO_DIMSUM(200)]), ";\n        line-height: normal;\n      ");
        break;

      case 'list':
        cssVar += "\n        font-size: ".concat(toMobile(props.theme.fontSizes[__UNSAFE_FONT_TO_DIMSUM(400)]), ";\n        line-height: normal;\n      ");
        break;

      case 'link':
        cssVar += "\n        line-height: ".concat(props.theme.lineHeights[3], ";\n        color: ").concat(props.theme.colors.brand['600'], ";\n        cursor: pointer;\n      ");
        break;
    }

    return cssVar;
  };
}
function iconColor() {
  var variant = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'neutral';
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 400;
  return css(["fill:", ";"], function (props) {
    return props.theme.colors[variant][type];
  });
}
function fakeBorder() {
  return css(["box-shadow:inset 0 0 0 1px ", ";border-radius:2px;"], function (props) {
    return props.theme.colors.neutral[200];
  });
}
function fakeActive() {
  return css(["outline:none;box-shadow:inset 0 0 0 1px ", ";border-radius:2px;"], function (props) {
    return props.theme.colors.brand[700];
  });
}
function clearFocus() {
  return "\n    border: none;\n    box-shadow: none;\n  ";
}
function buttonLink() {
  return "\n    background-color: transparent;\n    border: 1px solid transparent;\n    cursor: pointer;\n  ";
}
function transition() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'all 1s ease';
  return "\n    transition: ".concat(t, ";\n  ");
}

export { active, animation, border, boxShadow, buttonLink, clearFocus, color, createGlobalStyle, disabled, fakeActive, fakeBorder, flexCenter, focus, focusAfter, hover, iconColor, keyframes, kfrm, media, textStyle, transition, truncate, useTheme, withTheme };
//# sourceMappingURL=utils.js.map
